<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>

        <div class="block-content block-content-full mt-4 mb-1">
            <table class="table table-vcenter table-striped" v-if="emailsList">
                <thead>
                    <tr>
                        <th class="text-center">{{ $t('customer.month') }}</th>
                        <th class="text-center">{{ $t('customer.sms_sent_count') }}</th>
                        <th class="text-center">{{ $t('customer.actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in emailsList" :key="item.month.number">
                        <td class="text-center">{{ item?.month?.name }}</td>
                        <td class="text-center">{{ item?.value?.nbreSms }}</td>
                        <td class="text-center">
                            <button
                                class="btn fs-sm btn-dark px-4 rounded-8 fw-medium btn-more"
                                @click="fetchListSms(true, item?.value?.year, item?.month?.number)"
                                :disabled="item?.value?.nbreSms > 0 ? false : true"
                            >
                                {{ $t('customer.view_details') }}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <modal
            name="fullscreen-modal"
            width="90%"
            height="80%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-exit" @click="$modal.hide('fullscreen-modal')">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M10.9512 1.0498L1.05168 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M1.05078 1.0498L10.9503 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </button>
            <div class="email-list">
                <div class="block-content block-content-full">
                    <table class="table table-vcenter table-striped">
                        <thead>
                            <tr>
                                <th class="text-center">{{ $t('customer.sms_count') }}</th>
                                <th class="text-center">{{ $t('customer.content') }}</th>
                                <th class="text-center">{{ $t('customer.operation') }}</th>
                                <th class="text-center">{{ $t('customer.object') }}</th>
                                <th class="text-center">{{ $t('customer.start') }}</th>
                                <th class="text-center">{{ $t('customer.hour') }}</th>
                                <th class="text-center">{{ $t('customer.date') }}</th>
                                <th class="text-center">{{ $t('customer.actions') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in emailsListDetails" :key="item.id">
                                <td class="text-center">{{ item.nbreSms }}</td>
                                <td class="text-center">{{ showContent(item.description) }}</td>
                                <td class="text-center">{{ item.operation }}</td>
                                <td class="text-center">{{ item.object }}</td>
                                <td class="text-center">{{ item.start }}</td>
                                <td class="text-center">{{ item.hour }}</td>
                                <td class="text-center">{{ item.created_at }}</td>
                                <td class="text-center">
                                    <button @click="fetchSmsList(item.id)">
                                        <i class="fas fa-users"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </modal>

        <modal
            name="show-customers-modal"
            width="85%"
            height="75%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-exit" @click="$modal.hide('show-customers-modal')">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 12" fill="none">
                    <path
                        d="M10.9512 1.0498L1.05168 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <path
                        d="M1.05078 1.0498L10.9503 10.9493"
                        stroke="#94A3B8"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
            </button>
            <div class="email-list">
                <div class="block-content block-content-full">
                    <table class="table table-vcenter table-striped">
                        <thead>
                            <tr>
                                <th class="text-center">{{ $t('customer.last_name') }}</th>
                                <th class="text-center">{{ $t('customer.first_name') }}</th>
                                <th class="text-center">{{ $t('customer.email') }}</th>
                                <th class="text-center">{{ $t('customer.phone') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in customersList" :key="item.id">
                                <td class="text-center">{{ item?.user?.first_name ?? '-' }}</td>
                                <td class="text-center">{{ item?.user?.last_name ?? '-' }}</td>
                                <td class="text-center">{{ item?.user?.email }}</td>
                                <td class="text-center">{{ item?.user?.phone_number ?? '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pagination btn-base-client">
                    <button class="btn fs-sm btn-dark px-4 rounded-8 fw-medium m-1">
                        {{ $t('customer.page') }}: {{ currentPage }}
                    </button>
                    <button
                        class="btn fs-sm btn-dark px-4 rounded-8 fw-medium m-1"
                        @click="prevPage"
                        :disabled="currentPage === 1"
                    >
                        &laquo; {{ $t('customer.previous') }}
                    </button>
                    <!-- <span class="btn fs-sm btn-dark px-4 rounded-8 fw-medium m-1" v-for="page in totalPages" :key="page">
                        <button @click="goToPage(page)" :class="{ active: currentPage === page }">{{ page }}</button>
                    </span> -->
                    <button
                        class="btn fs-sm btn-dark px-4 rounded-8 fw-medium m-1"
                        @click="nextPage"
                        :disabled="currentPage === totalPages"
                    >
                        {{ $t('customer.next') }} &raquo;
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import ApiManager from './Api/ApiManagerBoCutomer.js'

export default {
    name: 'EmailList',
    components: {},
    data: () => ({
        emailsList: [],
        customersList: [],
        emailsListDetails: [],
        loading: false,
        currentPage: 1,
        totalPages: null,
        smsId: 0,
    }),
    methods: {
        async fetchListSms(details = false, year = '', month = '') {
            this.loading = true

            const params = {
                details: details,
                month: month,
                year: year,
            }

            try {
                const _data = await ApiManager.fetchListSms(params)

                if (details === true && _data) {
                    this.emailsListDetails = _data
                    this.$modal.show('fullscreen-modal')
                } else {
                    this.emailsList = _data
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
            }
        },

        async fetchSmsList(id, page = 1) {
            this.loading = true
            this.customersList = []
            this.smsId = id

            const params = {
                smsId: id,
                page: page,
            }

            try {
                const response = await ApiManager.fetchSendedSmsCustomersList(params)

                this.customersList = response.data
                this.currentPage = response.current_page
                this.totalPages = response.last_page

                this.$modal.show('show-customers-modal')
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
            }
        },

        async goToPage(id, page) {
            if (page >= 1 && page <= this.totalPages) {
                await this.fetchSmsList(this.smsId, page)
            }
        },
        async nextPage() {
            if (this.currentPage < this.totalPages) {
                await this.fetchSmsList(this.smsId, this.currentPage + 1)
            }
        },
        async prevPage() {
            if (this.currentPage > 1) {
                await this.fetchSmsList(id, this.currentPage - 1)
            }
        },

        showContent(description) {
            if (description.length > 50) {
                return description.substring(0, 50) + '...'
            }
            return description
        },
    },

    async mounted() {
        await this.fetchListSms()
    },
}
</script>

<style scoped>
.loader-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.loader {
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #333;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.table {
    width: 100%;
    text-transform: capitalize;
}

.email-list {
    overflow-y: auto;
    height: calc(100% - 120px);
    padding: 6rem 4rem;
}

.vm--modal {
    background-color: #f8fafc !important;
    padding: 1.5rem !important;
}

.btn-exit {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    width: 45px;
    height: 45px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #f8fafc !important;
    margin: 15px;
}

.btn-more {
    height: 40px !important;
    line-height: 25px !important;
}
</style>
